import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: 24,
	height: 24,
	viewBox: "0 0 100 100",
	enableBackground: "new 0 0 100 100",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M69.158,80.14H20.604c-2.757,0-5-2.243-5-5V40.724c0-2.757,2.243-5,5-5h48.555c2.757,0,5,2.243,5,5V75.14    C74.158,77.896,71.915,80.14,69.158,80.14z M20.604,37.724c-1.654,0-3,1.346-3,3V75.14c0,1.654,1.346,3,3,3h48.555    c1.654,0,3-1.346,3-3V40.724c0-1.654-1.346-3-3-3H20.604z",
			stroke: "#2771bb"
		}) }) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M81.218,68.261H77.4c-0.553,0-1-0.447-1-1s0.447-1,1-1h3.817c1.554,0,2.817-1.346,2.817-3V28.846c0-1.654-1.346-3-3-3    H32.48c-1.654,0-3,1.265-3,2.818v3.818c0,0.553-0.447,1-1,1s-1-0.447-1-1v-3.818c0-2.657,2.243-4.818,5-4.818h48.555    c2.757,0,5,2.243,5,5v34.415C86.035,66.018,83.874,68.261,81.218,68.261z",
			stroke: "#2771bb"
		}) }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("circle", {
				cx: 66.919,
				cy: 41.98,
				r: 1.5,
				stroke: "#2771bb"
			}) }) }),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("circle", {
				cx: 62.283,
				cy: 41.98,
				r: 1.5,
				stroke: "#2771bb"
			}) }) }),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("circle", {
				cx: 57.647,
				cy: 41.98,
				r: 1.5,
				stroke: "#2771bb"
			}) }) })
		] }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M69.166,48.582H20.599c-0.553,0-1-0.447-1-1s0.447-1,1-1h48.567c0.553,0,1,0.447,1,1S69.719,48.582,69.166,48.582z",
			stroke: "#2771bb"
		}) }) })
	]
});
const ForwardRef = forwardRef(SvgModal);
export default ForwardRef;
